import React, {FormEvent, PureComponent, ReactNode} from 'react';
import FormContext from './form-context';
import {FormGroup} from './form-group';

class State {
	formRef?: HTMLFormElement;
}

export interface FormProps extends React.DetailedHTMLProps<React.FormHTMLAttributes<HTMLFormElement>, HTMLFormElement> {
	controller: FormGroup<any, any>;
	disableAutoSubmit?: boolean;
}

export class Form extends PureComponent<FormProps, State> {
	public override readonly state = new State();
	private onSubmit = (e: FormEvent<HTMLFormElement>): void => {
		if (this.props.onSubmit) {
			this.props.onSubmit(e);
		}

		this.props.controller.submit && this.props.controller.submit();
	};

	public override render(): ReactNode {
		const {controller, ...formProps} = this.props;
		return <FormContext.Provider value={{formGroup: controller, formRef: this.state.formRef}}>
			<form
						autoComplete={'off'}
						{...formProps}
			      ref={(element) => this.setState({formRef: element})}
			      id={this.props.id}
			      onSubmit={(e) => {
				      !this.props.disableAutoSubmit && this.onSubmit(e);
				      e.preventDefault();
				      e.stopPropagation();
			      }}>
				{this.renderChild()}
			</form>
		</FormContext.Provider>;
	}

	renderChild(): ReactNode {
		if (this.state.formRef) {
			return this.props.children;
		} else {
			return <></>;
		}
	}
}

export default Form;
